import { lazy } from 'react'

export const WishVariant1 = lazy(() => import('./WishVariant1'))
